import Header from '@components/Header';
import colors from '@constants/colors';
import ReceiptIcon from '@icons/Receipt';
import { useFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

interface Props {
    orderId: string;
}

function OrderHeader({ orderId }:Props) {
    const { t } = useTranslation('orderLog');
    const { push } = useFlow();
    return (
        <Header title={t('header.title')}
            noShadow
            trailing={
                <ReceiptIcon color={colors.gray6}
                    size={24}
                    onClick={() => {
                        push('OrderReceiptActivity', { orderId });
                    }}/>
            }
        />
    );
}

export default OrderHeader;
